import { render, staticRenderFns } from "./perimeterAlarm.vue?vue&type=template&id=a85c28ca"
import script from "./perimeterAlarm.vue?vue&type=script&lang=js"
export * from "./perimeterAlarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports